module.exports = __webpack_public_path__ + "static/media/lv.2b8d0b5b.svg";